/*
  Rabatmotor — gave-regler (X+Y / x+x): lægger gaven automatisk i kurven.

  Efter hver kurv-ændring (temaets add/change/update + egne events) hentes
  /cart.js, og appen spørges (POST /api/v1/gifts) hvor mange stk af hvert
  gave-produkt kunden har ret til (beløbs-gaver regnes på linjernes pris efter
  rabat, final_line_price, i kurvens valuta). Gaven ligger i kurven som sin egen linje med
  den skjulte egenskab _rm_gift = regel-id (understregs-egenskaber vises ikke i
  kurven). Scriptet retter KUN sine egne markerede linjer til: tilføjer, ændrer
  antal eller fjerner — kundens egne linjer røres aldrig.

  Selve rabatten (gaven koster 0) gives af rabatmotorens kurv-funktion, som
  regner præcis som appen; markerede linjer tæller aldrig som køb.

  Fail-safe: fejler appen eller netværket, gøres INTET (gaven bliver liggende
  som den er; kurv-funktionen giver kun rabat hvis kunden har ret til den).

  Kunden bestemmer: fjerner kunden gaven (eller sætter antallet ned), huskes
  det for DEN kurv (localStorage, nøgle = kurvens token) — gaven lægges ikke
  ind igen, heller ikke hvis kunden køber mere. Scriptets egne ændringer tæller
  ikke som et nej. Ny/tømt kurv = frisk start.
  Indlæses fra layout/theme.liquid med data-app-url og data-country.

  "Samme produkt"-gaver (4/10-2026): én regel kan give gaver af flere produkter
  (hvert købt produkt får sit eget), så gave-linjerne holdes pr. regel OG
  produkt (nøgle "regel:produkt"), og linjernes variant sendes med — appen
  vælger den mest købte variant som gave.
*/
(function () {
  if (window.__rmGifts) return;
  window.__rmGifts = true;

  var script = document.currentScript;
  var appUrl = ((script && script.dataset.appUrl) || '').replace(/\/+$/, '');
  var market = (script && script.dataset.country) || '';
  if (!appUrl) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var OWN = 'X-RM-Gift'; // markerer vores egne kurv-kald, så de ikke udløser en ny runde
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var running = false;
  var again = false;
  var rounds = 0;
  var STORE = 'rm-gifts-v1';

  // { token, last: {nøgle: antal efter vores seneste runde}, cap: {nøgle: kundens loft} }
  // nøgle = "regel:produkt" (en "samme produkt"-regel har én gave pr. købt produkt)
  function loadState(token) {
    try {
      var st = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (st && st.token === token && st.last && st.cap) return st;
    } catch (e) { /* privat vindue m.m. */ }
    return { token: token, last: {}, cap: {} };
  }
  function saveState(st) {
    try { localStorage.setItem(STORE, JSON.stringify(st)); } catch (e) { /* ignorer */ }
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay == null ? 350 : delay);
  }

  function cartReq(path, body) {
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[OWN] = '1';
    return nativeFetch(root + path, { method: 'POST', headers: headers, body: JSON.stringify(body) })
      .then(function (res) { if (!res.ok) throw new Error('cart ' + res.status); return res.json(); });
  }

  function giftRule(item) {
    var v = item.properties && item.properties._rm_gift;
    return v != null && /^\d{1,12}$/.test(String(v)) ? String(v) : '';
  }
  function giftKey(item) {
    var r = giftRule(item);
    return r ? r + ':' + item.product_id : '';
  }

  function sync() {
    if (running) { again = true; return; }
    running = true;
    var changed = false;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) { if (!res.ok) throw new Error('cart.js'); return res.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var lines = items.map(function (it) {
          // paid = linjens pris efter rabat (cents) — beløbs-gaver ("køb for 50 €")
          return { product_id: String(it.product_id), variant_id: String(it.variant_id), qty: it.quantity, gift: giftRule(it), paid: it.final_line_price };
        });
        var hasMarked = items.some(function (it) { return giftRule(it); });
        // Tom kurv: intet at spørge om — og kundens tidligere nej glemmes
        if (!lines.length) {
          try { localStorage.removeItem(STORE); } catch (e) { /* ignorer */ }
          return null;
        }
        // Har KUNDEN ændret en gave-linje siden vores seneste runde? Mindre end vi
        // efterlod = kundens nye loft (0 = fjernet); mere = kunden vil have den.
        var state = loadState(cart.token || '');
        var marked = {};
        items.forEach(function (it) { var k = giftKey(it); if (k) marked[k] = (marked[k] || 0) + it.quantity; });
        Object.keys(state.last).forEach(function (r) {
          var cur = marked[r] || 0;
          if (cur < state.last[r]) state.cap[r] = cur;
          else if (cur > state.last[r]) delete state.cap[r];
        });
        return nativeFetch(appUrl + '/api/v1/gifts', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ shop: (window.Shopify && window.Shopify.shop) || '', market: market, currency: cart.currency || '', lines: lines })
        })
          .then(function (res) { if (!res.ok) throw new Error('gifts ' + res.status); return res.json(); })
          .then(function (data) {
            if (!data || !Array.isArray(data.gifts)) throw new Error('gifts svar');
            if (!data.gifts.length && !hasMarked) { state.last = {}; saveState(state); return null; }
            return reconcile(items, data.gifts, state.cap).then(function (res) {
              changed = res.changed;
              state.last = res.final;
              saveState(state);
            });
          });
      })
      .catch(function () { /* fail-safe: rør ikke kurven */ })
      .then(function () {
        running = false;
        if (changed) {
          refreshCartUi();
          // Temaets egne lyttere (subtotal, fragt-bar m.m.) — vores egen lytter
          // kører en runde mere, som finder alt i orden og stopper.
          rounds += 1;
          if (rounds < 4) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { rmGifts: true } }));
        } else {
          rounds = 0;
        }
        if (again) { again = false; schedule(); }
      });
  }

  // Ret markerede linjer til, så de matcher appens svar (højst kundens loft).
  // → Promise<{ changed, final: {nøgle: antal} }>
  function reconcile(items, gifts, cap) {
    var want = {}; // "regel:produkt" → { rule, variant, qty }
    gifts.forEach(function (g) {
      if (!g || g.rule_id == null || !g.product_id || !g.variant_id || !(g.qty > 0)) return;
      var rule = String(g.rule_id);
      var key = rule + ':' + g.product_id;
      var qty = cap && cap[key] != null ? Math.min(g.qty, cap[key]) : g.qty;
      if (qty > 0) want[key] = { rule: rule, variant: String(g.variant_id), qty: qty };
    });
    var final = {};
    Object.keys(want).forEach(function (key) { final[key] = want[key].qty; });
    var ops = []; // udføres i rækkefølge (linje-nøgler ændrer sig ikke ved change)
    var have = {};
    items.forEach(function (it) {
      var key = giftKey(it);
      if (!key) return;
      var w = want[key];
      if (!w || String(it.variant_id) !== w.variant || have[key]) {
        ops.push({ change: it.key, qty: 0 }); // ingen ret / forkert variant / dublet-linje
        return;
      }
      have[key] = true;
      if (it.quantity !== w.qty) ops.push({ change: it.key, qty: w.qty });
    });
    var adds = [];
    Object.keys(want).forEach(function (key) {
      if (!have[key]) adds.push({ id: Number(want[key].variant), quantity: want[key].qty, properties: { _rm_gift: want[key].rule } });
    });
    if (!ops.length && !adds.length) return Promise.resolve({ changed: false, final: final });
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () { return cartReq('cart/change.js', { id: op.change, quantity: op.qty }); });
    });
    if (adds.length) {
      chain = chain.then(function () {
        // Udsolgt gave → Shopify afviser; resten af kurven er upåvirket
        return cartReq('cart/add.js', { items: adds }).catch(function () {});
      });
    }
    return chain.then(function () { return { changed: true, final: final }; });
  }

  // Opdater kurv-skuffen/kurv-siden STILLE (temaets refreshCart åbner skuffen,
  // og atlantic overskriver den, så den kaster) — samme udskiftning som den.
  function refreshCartUi() {
    var form = document.getElementById('AjaxCartForm');
    if (!form) return;
    nativeFetch('?section_id=helper-cart')
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newForm = doc.getElementById('AjaxCartForm');
        var newSub = doc.getElementById('AjaxCartSubtotal');
        if (!newForm) return;
        form.innerHTML = newForm.innerHTML;
        if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
        var count = form.querySelector('[data-cart-count]');
        var total = form.querySelector('[data-cart-total]');
        if (count) document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.textContent = count.textContent; });
        if (total) document.querySelectorAll('[data-header-cart-total]').forEach(function (el) { el.textContent = total.textContent; });
        var sub = document.getElementById('AjaxCartSubtotal');
        if (sub && newSub) sub.innerHTML = newSub.innerHTML;
      })
      .catch(function () {});
  }

  // Alle kurv-ændringer: temaets fetch-kald til /cart/add|change|update|clear.
  // Vores egne kald bærer X-RM-Gift og går uden om (nativeFetch).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) schedule(); }).catch(function () {});
    }
    return p;
  };
  // Ældre XHR-kald (apps) — samme mønster
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''))) {
      this.addEventListener('load', function () { if (this.status < 400) schedule(); });
    }
    return nativeOpen.apply(this, arguments);
  };
  document.addEventListener('cart:updated', function (e) { if (!(e.detail && e.detail.rmGifts)) schedule(); });

  // Første runde: kurven kan allerede opfylde en regel (fx efter login/tilbagevenden)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(600); });
  else schedule(600);
})();
